import App from './App';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { hydrate } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { createAppStore } from './redux';
import {APPLICATION_CONTAINER_ID, DEFAULT_THEME} from './constants';

const store = createAppStore(window.__initialState__);

const params = new URLSearchParams(window.location.search);
const themeParam = params.get('theme');
const theme = (themeParam === 'light' || themeParam === 'dark') ? themeParam : DEFAULT_THEME;

hydrate(
  <ReduxProvider store={store}>
    <BrowserRouter>
      <App theme={theme} />
    </BrowserRouter>
  </ReduxProvider>,
  document.getElementById(APPLICATION_CONTAINER_ID)
);

if (module.hot) {
  module.hot.accept();
}
